import {routes} from "../Router/routes";
import {MenuModel} from "../types";

export const MenuItems : MenuModel[] = [

    {
        label: "Dashboards",
        icon: "pi pi-home",
        items: [
            {label: "Home", icon: "pi pi-fw pi-home", to: routes.home, description:"Home page of the application"},
            {label: "Reporting", icon: "pi pi-fw pi-chart-bar", to: routes.reports, description:"Reports page of the application"},
            // {label: "Map Practice", icon: "", to: routes.mapPractice, description:"Map practice page for testing map related features"},
        ],
    },
    {
        label: "Management",
        icon: "pi pi-th-large",
        items: [
            {
                label: "Administration",
                icon: "pi pi-fw pi-users",
                items: [
                    // {label: "Manage Roles", icon: "pi pi-pw pi-wrench ",  to: routes.manageRoles, description:""},
                    // {label: "Manage Users", icon: "",  to: "", description:""},
                    // {label: "Manage External Users", icon: "",  to: "", description:""},
                    {label: "Add Employees", icon: "pi pi-pw pi-user-edit",  to: routes.addEmployee, description:""},
                    {label: "Manage Employees", icon: "pi pi-pw pi-verified",  to: routes.manageEmployees, description:""},
                    // {label: "Manage Drivers", icon: "",  to: "", description:""},

                ],
            },
            {
                label: "Vehicle",
                icon: "pi pi-pw pi-car",
                items: [
                    {label: "Manage Vehicle", icon: "pi pi-pw fa-regular fa-truck",  to: routes.manageVehicles, description:""},
                    {label: "Assign Driver", icon: "pi pi-pw pi-key",  to: routes.assignDriver, description:""},
                    {label: "Vehicle Ownership", icon: "pi pi-pw fa-regular fa-chess-king",  to: routes.vehicleOwnership, description:""},
                    // {label: "Vehicle Requisition", icon: "",  to: "", description:""},
                ],
            },
            // {
            //     label: "Accidents & Occurrences",
            //     icon: "",
            //     items: [
            //         {label: "Manage Accidents & Occurrences", icon: "",  to: "", description:""},
            //     ],
            // },
            {
                label: "Re-fueling",
                icon: "pi pi-pw pi-spinner-dotted",
                items: [
                    // {label: "Fuel Stations", icon: "",  to: "", description:""},
                    {label: "Re-fueling Log", icon: "pi pi-pw pi-hourglass",  to: routes.refuelingLog, description:""},
                ],
            },
            // {
            //     label: "Maintenance",
            //     icon: "",
            //     items: [
            //         {label: "Manage Maintenances", icon: "",  to: "", description:""},
            //         {label: "Maintenance Services", icon: "",  to: "", description:""},
            //         {label: "PM Services", icon: "",  to: "",},
            //         {label: "Accessories Bidding", icon: "",  to: "", description:""},
            //     ],
            // },
            {
                label: "Pickup and Drop",
                icon: "pi pi-pw pi-map-marker",
                items: [
                    {label: "Manage Routes", icon: "pi pi-pw pi-map",  to: routes.manageRoute, description:""},
                    // {label: "Manage Trip Rules", icon: "",  to: "", description:""},
                    {label: "Pickup and Drop", icon: "pi pi-pw pi-compass",  to: routes.managePickupAndDrop,description:""},
                ],
            },
            // {
            //     label: "Inventory",
            //     icon: "",
            //     items: [
            //         {label: "Items", icon: "",  to: "", description:""},
            //         {label: "Stocks", icon: "",  to: "", description:""},
            //     ],
            // },
            // {
            //     label: "Finance",
            //     icon: "",
            //     items: [
            //         {label: "Expenses", icon: "",  to: "", description:""},
            //         {label: "Loan", icon: "",  to: "", description:""},
            //     ],
            // },
            // {
            //     label: "Vendor",
            //     icon: "",
            //     items: [
            //         {label: "Manage Vendor", icon: "",  to: "", description:""},
            //     ],
            // },
            // {
            //   label: "Finance Management",
            //   icon: "",
            //   items: [
            //       {label: "Loan", icon: "",  to: "",},
            //   ],
            // },

            {
                label: "Parking",
                icon: "pi pi-pw fa-solid fa-square-parking",
                items: [
                    {label: "Parking Reservations", icon: "pi pi-pw fa-regular fa-bookmark",  to: routes.parkingReservations, description:""},
                    {label: "Parking Slots", icon: "pi pi-pw fa-regular fa-rectangle-xmark ",  to: routes.parkingSlots, description:""},
                ],
            }


        ]
    },
    {
        label: "Settings",
        icon: "pi pi-th-large",
        items: [
            // {label: "Company Profile", icon: "pi pi-pw pi-verified", to: routes.settingsProfile, description: "Company profile settings page"},
            {label: "Configurations", icon: "pi pi-pw pi-cog", to: routes.settingsConfiguration, description:"Configuration settings page for the application"},
            // {
            //     label: "General",
            //     icon: "fa-solid fa-recycle",
            //     items: [
            //         {label: "Menu Ordering", icon: "", to: "", description:""},
            //         {label: "Company Departments", icon: "", to: "", description:""},
            //         {label: "Captured Documents Types", icon: "", to: "", description:""},
            //         {label: "Designation Types", icon: "", to: "", description:""},
            //         {label: "BRTA Circle Offices", icon: "", to: "", description:""},
            //         {label: "Region", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Administration",
            //     icon: "",
            //     items: [
            //         {label: "Roles & Permissions", icon: "", to: "",description:""},
            //         {label: "User Type", icon: "", to: "", description:""}
            //     ],
            // },
            // {
            //     label: "Approval Authority",
            //     icon: "",
            //     items: [
            //         {label: "Vehicle Requisition", icon: "", to: "", description:""},
            //         {label: "Vehicle Re-fueling", icon: "", to: "", description:""},
            //         {label: "Maintenance", icon: "", to: "", description:""},
            //         {label: "Pickup and Drop", icon: "", to: "", description:""},
            //     ],
            // },
            // {
            //     label: "Re-Fueling",
            //     icon: "",
            //     items: [
            //         {label: "Fuel Types", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Maintenance",
            //     icon: "",
            //     items: [
            //         {label: "Service Types", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Pickup and Drop",
            //     icon: "",
            //     items: [
            //         {label: "Trip Rules", icon: "", to: "",}
            //     ]
            // },
            // {
            //     label: "Inventory",
            //     icon: "",
            //     items: [
            //         {label: "Layer Control", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Cost Management",
            //     icon: "",
            //     items: [
            //         {label: "Expense Types", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Vendor Management",
            //     icon: "",
            //     items: [
            //         {label: "Vendor Types", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Vehicle",
            //     icon: "",
            //     items: [
            //         { label: "Types", icon: "", to: "" ,description:""},
            //         { label: "Brand Name", icon: "", to: "" ,description:""},
            //         { label: "Group Name", icon: "", to: "" ,description:"" },
            //         { label: "Ownership Types", icon: "", to: "" ,description:""},
            //         { label: "Cam Types", icon: "", to: "" ,description:"" },
            //         { label: "Brake system Types", icon: "", to: "" ,description:"" },
            //         { label: "Aspiration types", icon: "", to: "" ,description:"" },
            //         { label: "Transmission Types", icon: "", to: "" ,description:"" },
            //         { label: "Statuses", icon: "", to: ""  ,description:""},
            //         { label: "Documentation Types", icon: "", to: "" ,description:"" },
            //         { label: "Sub Group", icon: "", to: "" ,description:"" },
            //         { label: "Body Types", icon: "", to: "" ,description:""},
            //     ],
            // },
            // {
            //     label: "Driver",
            //     icon: "",
            //     items: [
            //         {label: "Driving license Types", icon: "", to: "", description:""}
            //     ]
            // },
            // {
            //     label: "Parking",
            //     icon: "",
            //     items: [
            //         { label: "Garage", icon: "", to: "" ,description:""},
            //         { label: "Floors", icon: "", to: "" ,description:"" },
            //         { label: "Slots Types", icon: "", to: "" ,description:""},
            //         { label: "Campuses", icon: "", to: "" ,description:""},
            //     ],
            // },
            // {
            //     label: "Finance",
            //     icon: "",
            //     items: [
            //         { label: "Loan Types", icon: "", to: ""  ,description:""},
            //         { label: "Manage Branches", icon: "", to: "" ,description:"" },
            //         { label: "Manage Banks ", icon: "", to: "" ,description:""},
            //         { label: "Payment Methods", icon: "", to: "" ,description:""},
            //     ],
            // },
        ]
    },

];


